import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormView } from './FormView';

export const AddressFormStep = ({ control, handleConfirm, isLoading, personalAddressFields }: any) => {
  const { t } = useTranslation();
  // const { getValues, watch, setError } = useFormContext();
  // const { handleForward } = useChangeAddressStepHook({ setError });
  // const handleConfirm = useCallback(() => {
  //   handleForward();
  // }, [getValues, watch]);
  return (
    <FormView
      isLoading={isLoading}
      buttonTitle={t('UPDATE_BUSINESS_ADDRESS.MODAL_CTA')}
      handleClick={handleConfirm}
      control={control}
      personalAddressFields={personalAddressFields}
    />
  );
};
